import React from 'react';
import { InputText } from 'primereact/inputtext';

const ClassFilter = ({
  user,
  openCreateDialog,
  globalFilterValue,
  onGlobalFilterChange
}) => {
  return (
    <div className="mb-4">
      <div className="bg-white/80 backdrop-blur-xl rounded-xl shadow-lg border border-white/20 p-4 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-indigo-500/10 rounded-full -translate-y-16 translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full translate-y-12 -translate-x-12"></div>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <div className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-lg mr-3">
              <i className="pi pi-book text-white text-sm"></i>
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-900">Classes Management</h3>
              <p className="text-xs text-gray-600 mt-0.5">Manage academic classes and their sections</p>
            </div>
          </div>

          {(user?.role === 'admin' || user?.role === 'teacher') && (
            <button type="button" onClick={openCreateDialog} className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl text-sm">
              <i className="pi pi-plus text-sm"></i> Add Class
            </button>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-search mr-1 text-blue-500 text-xs"></i>Search</label>
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search classes..." className="w-full pl-3 pr-3 py-2 text-sm border border-gray-200 rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassFilter;
